<div class="page-layout blank p-24" fusePerfectScrollbar>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Relação de documentos</mat-card-title>
    </mat-card-header>

    <mat-card-content fxLayoutAlign="center center" fxLayout="column">
      <div style="width: 80%">
        <mat-tab-group (selectedIndexChange)="onTabChange($event)">
          <mat-tab *ngFor="let tipo of tiposDocumentos" [label]="tipo.label">
            
            <!-- Loading -->
            <div *ngIf="loading[tipo.value]" class="loading-container">
              <mat-spinner></mat-spinner>
            </div>

            <!-- Lista de documentos -->
            <ng-container *ngIf="!loading[tipo.value] && laudoList?.length; else semDocs">
              <div class="cards-container">
                <div class="card-item" *ngFor="let element of laudoList">
                  <div class="card-header">
                    <div class="card-date">
                      {{ element.date | date: "dd/MM/yyyy" }}
                    </div>

                    <div class="card-actions">
                      <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Visualizar documento"
                        (click)="exibirDocumet(element.idDocumento, element.idPaciente, element.type)"
                      >
                        <mat-icon>find_in_page</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Baixar documento"
                        (click)="preparaDownload(element.idDocumento, element.idPaciente, element.type)"
                      >
                        <mat-icon>get_app</mat-icon>
                      </button>
                    </div>
                  </div>

                  <div class="card-body">
                    <div class="info-line">
                      <span class="label">Tipo:</span>
                      <span class="value">{{ element.type }}</span>
                    </div>
                    <div class="info-line" *ngIf="element.description">
                      <span class="label">Descrição:</span>
                      <span class="value">{{ element.description }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- paginator abaixo -->
              <div class="paginator-wrapper">
                <mat-paginator
                  #paginator
                  showFirstLastButtons
                  [length]="totalElements"
                  [pageIndex]="pagina"
                  [pageSizeOptions]="[10, 20]"
                  (page)="buscarLaudo($event, 'page')">
                </mat-paginator>
              </div>
            </ng-container>

            <!-- Nenhum documento -->
            <ng-template #semDocs>
              <div class="empty-state">
                Nenhum documento encontrado para este tipo.
              </div>
            </ng-template>

          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-card-content>
  </mat-card>
</div>
